import BaseApi from '../base/base'
import Exam from '../../models/exam'
import ExamStatusForm from '../../forms/answer_status';

export default class ExamStatusApi extends BaseApi {
  constructor () {
    super()
    this.path = '/exam_status'
  }

  async patch (examId: number, examStatusForm: ExamStatusForm) {
    this.path = `/exam_status/${examId}`
    const response = await this.patchRequest({...examStatusForm})
    return new Exam(response.data)
  }
}
